export default {
  name: 'remotekey',
  type: 'detail',
  active: false,
  data: {
    margin: '0',
    size: '100',
    img: ''
  }
}
